// extracted by mini-css-extract-plugin
export var equalColumn = "_gh-0";